import { PersonBadge } from '@/models/PersonBadge';

export enum AchievementsTypes {
    UPDATE_ACHIEVEMENTS_NOTIFICATION_REQUEST = '@achievements/UPDATE_ACHIEVEMENTS_NOTIFICATION_REQUEST',
    UPDATE_ACHIEVEMENTS_NOTIFICATION_SUCCESS = '@achievements/UPDATE_ACHIEVEMENTS_NOTIFICATION_SUCCESS',
    UPDATE_ACHIEVEMENTS_NOTIFICATION_FAILURE = '@achievements/UPDATE_ACHIEVEMENTS_NOTIFICATION_FAILURE',
    UPDATE_ACHIEVEMENTS_INFO_REQUEST = '@achievements/UPDATE_ACHIEVEMENTS_INFO_REQUEST',
    UPDATE_ACHIEVEMENTS_INFO_SUCCESS = '@achievements/UPDATE_ACHIEVEMENTS_INFO_SUCCESS',
    UPDATE_ACHIEVEMENTS_INFO_FAILURE = '@achievements/UPDATE_ACHIEVEMENTS_INFO_FAILURE',
    LIST_ACHIEVEMENTS_REQUEST = '@achievements/LIST_ACHIEVEMENTS_REQUEST',
    LIST_ACHIEVEMENTS_SUCCESS = '@achievements/LIST_ACHIEVEMENTS_SUCCESS',
    LIST_ACHIEVEMENTS_FAILURE = '@achievements/LIST_ACHIEVEMENTS_FAILURE',
}

export interface AchievementsState {
    loading: boolean;
    success: boolean;
    hasError: boolean;
    personBadges: PersonBadge[];
}
